import { passkeyClient } from "@better-auth/passkey/client";
import type { OrganizationClientOptions } from "better-auth/client/plugins";
import { emailOTPClient, organizationClient } from "better-auth/client/plugins";
import type { ReactAuthClient } from "better-auth/react";
import { createAuthClient } from "better-auth/react";

export const authClient: ReactAuthClient<{
  // An uninstantiated generic resolves to `any`, which would erase every plugin's actions.
  plugins: [
    ReturnType<typeof organizationClient<OrganizationClientOptions>>,
    ReturnType<typeof emailOTPClient>,
    ReturnType<typeof passkeyClient>,
  ];
}> = createAuthClient({
  plugins: [organizationClient(), emailOTPClient(), passkeyClient()],
  fetchOptions: {
    // The server writes account emails in the language the app is showing.
    onRequest: <T extends { headers?: HeadersInit }>(context: T) => {
      const headers = new Headers(context.headers);
      headers.set("x-prea-locale", document.documentElement.lang || "pt-BR");
      return { ...context, headers };
    },
  },
});
